import InputNumber from 'formik-antd/es/input-number';
import 'formik-antd/es/input-number/style/css';
import { nameOf } from '../../../common/helper/helper';
import CheckOutFactory from '../../DonateForm/Components/CheckoutFactory';
import { IDonateFormProps } from '../../GenericForm/Components/Constants';
import { EventRegFormModel } from '../../ml_modules/websiteApi/EventRegFormModel';
import { PaypalButton } from '../../PaypalButton';

interface IEventRegFormCheckOutComponentProps {
	maximumTicketsPerReg: number;
	ticketsLeft: number;
	totalTickets: number;
	errors: any;
	touched: any;
	colorTheme: string;
	paymentRequired: boolean;
	ticketCost: number;
	values: EventRegFormModel;
	paymentError: any;
	setPaymentError: any;
	setPaymentComplete: (complete: boolean) => void;
	isColumn: boolean;
	isEventReg: boolean;
	contentId: string | number;
	stripe: any;
	updateTokenGenerator: (func: () => Promise<any>) => void;
	paymentProvider: string;
	setFieldValue: (field: string, value: string | string[] | number) => void;
	submitForm: () => void;
	isSubmitting: boolean;
	submitDisabled: boolean;
	paypalClientId: string;
	setPayPalTransactionId: (tranactionId: string) => void;
}

export interface ITokenGeneratorResponseProps extends IDonateFormProps {
	ContentId: number;
	SecureToken: string;
	MaskedCardNumber?: string;
	PaymentProvider?: string;
}

export default (props: IEventRegFormCheckOutComponentProps): JSX.Element => {
	const contentId = props.contentId.toString();

	const totalPrice = (props.values.NumberOfTickets ?? 0) * props.ticketCost;

	return (
		<div className="checkout-component">
			{props.maximumTicketsPerReg && props.maximumTicketsPerReg > 1 && (
				<InputNumber
					min={1}
					max={
						props.totalTickets > 0
							? props.ticketsLeft < props.maximumTicketsPerReg
								? props.ticketsLeft
								: props.maximumTicketsPerReg
							: props.maximumTicketsPerReg
					}
					placeholder="Number of tickets"
					onChange={v => {
						props.setFieldValue(nameOf<EventRegFormModel>('NumberOfTickets'), v);
					}}
					name={nameOf<EventRegFormModel>('NumberOfTickets')}
					className="update-payment-details-field num-of-ticket"
				/>
			)}
			<p className="col-md-12 total-price">Total Price: ${totalPrice}</p>
			{props.paymentRequired ? (
				<>
					<CheckOutFactory
						setComplete={props.setPaymentComplete}
						values={props.values}
						contentId={contentId}
						setSubmitError={props.setPaymentError}
						stripe={props.stripe}
						updateTokenGenerator={props.updateTokenGenerator}
						provider={props.paymentProvider}
					/>
					{props.paypalClientId !== undefined && props.paypalClientId !== '' && totalPrice > 0 ? (
						<PaypalButton
							contentId={contentId}
							textColorClass={'genOpposite' + props.colorTheme}
							paymentProvider={props.paymentProvider}
							setFieldValue={props.setFieldValue}
							setSubmitError={props.setPaymentError}
							submitForm={props.submitForm}
							paypalClientId={props.paypalClientId}
							disabled={props.submitDisabled}
							amount={totalPrice?.toString()}
							interval="one"
							transactionDescription="Ticket"
							setPayPalTransactionId={props.setPayPalTransactionId}
						/>
					) : null}
				</>
			) : (
				<></>
			)}
		</div>
	);
};
